module.exports = __webpack_public_path__ + "static/media/calendar-icon.c00f5033.svg";